import React, { useState, useEffect } from "react";
import DashboardNav from "./dashboardNav";
import classes from "./FerryBooking.module.css";
import { Modal, ModalBody } from "react-bootstrap";
import Confirm from "./ConfirmModal/Confirm";
import LoginServices from "../../services/LoginServices";

const ROUTES = [
    { id: "mumbai-vijaydurg", label: "Mumbai -> Vijaydurg", basePrice: 1500 },
    { id: "mumbai-goa", label: "Mumbai -> Goa", basePrice: 2500 },
    { id: "mumbai-alibaug", label: "Mumbai -> Alibaug", basePrice: 400 },
    { id: "gateway-elephanta", label: "Gateway of India -> Elephanta Caves", basePrice: 200 },
    { id: "bhaucha-mandwa", label: "Bhaucha Dhakka -> Mandwa", basePrice: 350 }
];

const DEPARTURE_TIMES = [
    "09:00 AM",
    "11:00 AM",
    "01:00 PM",
    "03:00 PM",
    "05:00 PM"
];

const PASSENGERS = [1, 2, 3, 4, 5];

const VEHICLE_TYPES = [
    { id: "no-vehicle", label: "No Vehicle", price: 0 },
    { id: "2-wheeler", label: "2-Wheeler", price: 500 },
    { id: "4-wheeler-hatchback", label: "4-Wheeler (Hatchback)", price: 1500 },
    { id: "4-wheeler-suv", label: "4-Wheeler (Sedan/SUV)", price: 2000 }
];

const FerryBooking = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [route, setRoute] = useState(ROUTES[0].id);
    const [travelDate, setTravelDate] = useState("");
    const [departureTime, setDepartureTime] = useState(DEPARTURE_TIMES[2]);
    const [passengers, setPassengers] = useState(1);
    const [vehicleType, setVehicleType] = useState(VEHICLE_TYPES[0].id);

    // Payment Gateway & Confirm Modals State
    const [showGatewayModal, setShowGatewayModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [PaymentGateWay, setPaymentGateWay] = useState<any>("");
    const [PayableAmount, setPayableAmount] = useState(0);
    const [commissionPercentage, setCommissionPercentage] = useState(0);
    const [spin, setSpin] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);

    const [AllGateways, setAllGateways] = useState({
        isRazorPayPGAvailable: 1,
        isCashfreeEduAvailable: 0,
        isCashFreeAvailable: 0,
        isZwitchAvailable: 0,
        isCashfreeFastAvailable: 0,
    });

    useEffect(() => {
        let config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        };
        LoginServices.getGatewayStatus(config)
            .then((response: any) => {
                if (response.data.Status == 1) {
                    setAllGateways({
                        isCashFreeAvailable: response?.data?.isCashFreeAvailable,
                        isCashfreeEduAvailable: response?.data?.isCashfreeEduAvailable,
                        isRazorPayPGAvailable: response?.data?.isRazorPayPGAvailable,
                        isZwitchAvailable: response?.data?.isZwitchAvailable,
                        isCashfreeFastAvailable: response?.data?.isCashfreeFastAvailable,
                    });
                }
            })
            .catch((e: Error) => {
                console.log(e);
            });
    }, []);

    const handleContinue = (e: React.FormEvent) => {
        e.preventDefault();

        // Calculate dynamic price
        const selectedRoute = ROUTES.find(r => r.id === route);
        const selectedVehicle = VEHICLE_TYPES.find(v => v.id === vehicleType);

        if (selectedRoute && selectedVehicle) {
            const calculatedTotal = (selectedRoute.basePrice * passengers) + selectedVehicle.price;
            setTotalPrice(calculatedTotal);
            setPaymentGateWay("");
            setShowGatewayModal(true);
        }
    };

    const handleProceedToConfirm = (e: React.FormEvent) => {
        e.preventDefault();
        if (!PaymentGateWay) {
            alert("Please select a payment gateway.");
            return;
        }

        let Commission =
            PaymentGateWay == 1
                ? 2.0 // RazorPayPercentage
                : PaymentGateWay == 2
                    ? 1.5 // CashfreeUtilityPercentage
                    : PaymentGateWay == 3
                        ? 1.2 // CashfreeEduPercentage
                        : PaymentGateWay == 4
                            ? 1.8 // CashfreefastPercentage
                            : 2.5; // ZwitchPercentage

        setCommissionPercentage(Commission);
        setPayableAmount(
            Math.ceil(
                (totalPrice * (Commission / 100) + totalPrice) * 100
            ) / 100
        );

        setShowGatewayModal(false);
        setShowConfirmModal(true);
    };

    return (
        <div className="main-section">
            <DashboardNav />
            <div className={classes.mainContainer}>
                <div className={classes.formCard}>
                    <h2 className={classes.title}>Trip Details</h2>
                    <p className={classes.subtitle}>Select your route and travel date</p>

                    <form onSubmit={handleContinue}>
                        <div className={classes.formGroup}>
                            <label className={classes.label}>Name</label>
                            <input
                                type="text"
                                className={classes.inputControl}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter your full name"
                                required
                            />
                        </div>

                        <div className={classes.row}>
                            <div className={classes.col}>
                                <label className={classes.label}>Email</label>
                                <input
                                    type="email"
                                    className={classes.inputControl}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter email address"
                                    required
                                />
                            </div>
                            <div className={classes.col}>
                                <label className={classes.label}>Phone Number</label>
                                <input
                                    type="tel"
                                    className={classes.inputControl}
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    placeholder="Enter phone number"
                                    required
                                />
                            </div>
                        </div>

                        <div className={classes.formGroup}>
                            <label className={classes.label}>Route</label>
                            <select
                                className={classes.inputControl}
                                value={route}
                                onChange={(e) => setRoute(e.target.value)}
                                required
                            >
                                <option value="" disabled>Select a Route</option>
                                {ROUTES.map(r => (
                                    <option key={r.id} value={r.id}>{r.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className={classes.formGroup}>
                            <label className={classes.label}>Travel Date</label>
                            <input
                                type="date"
                                className={classes.inputControl}
                                value={travelDate}
                                onChange={(e) => setTravelDate(e.target.value)}
                                required
                            />
                        </div>

                        <div className={classes.formGroup}>
                            <label className={classes.label}>Departure Time</label>
                            <select
                                className={classes.inputControl}
                                value={departureTime}
                                onChange={(e) => setDepartureTime(e.target.value)}
                                required
                            >
                                {DEPARTURE_TIMES.map(t => (
                                    <option key={t} value={t}>{t}</option>
                                ))}
                            </select>
                        </div>

                        <div className={classes.row}>
                            <div className={classes.col}>
                                <label className={classes.label}>Passengers</label>
                                <select
                                    className={classes.inputControl}
                                    value={passengers}
                                    onChange={(e) => setPassengers(Number(e.target.value))}
                                    required
                                >
                                    {PASSENGERS.map(p => (
                                        <option key={p} value={p}>{p}</option>
                                    ))}
                                </select>
                            </div>


                        </div>

                        <button type="submit" className={classes.submitBtn}>
                            Continue
                        </button>
                    </form>
                </div>
            </div>

            {/* Gateway Modal */}
            <Modal show={showGatewayModal} onHide={() => setShowGatewayModal(false)} centered>
                <ModalBody>
                    <div style={{ padding: '20px' }}>
                        <h4 style={{ marginBottom: '20px', fontWeight: 'bold' }}>Select Payment Gateway</h4>
                        <p style={{ marginBottom: '5px' }}>Booking: <strong>{ROUTES.find(r => r.id === route)?.label}</strong></p>
                        <p style={{ marginBottom: '5px' }}>Passengers: <strong>{passengers}</strong></p>
                        <p style={{ marginBottom: '20px' }}>Vehicle: <strong>{VEHICLE_TYPES.find(v => v.id === vehicleType)?.label}</strong></p>
                        <p style={{ marginBottom: '20px', fontSize: '18px' }}>Total Amount: <strong>₹{totalPrice.toLocaleString('en-IN')}</strong></p>

                        <form onSubmit={handleProceedToConfirm}>
                            <div className="drop-down amount-data" style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600 }}>Payment Gateway</label>
                                <select
                                    className="form-control"
                                    value={PaymentGateWay}
                                    onChange={(e) => setPaymentGateWay(e.target.value)}
                                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', appearance: 'auto', backgroundColor: '#fff' }}
                                    required
                                >
                                    <option value="">Select Payment Gateway</option>
                                    <option value={2} disabled={AllGateways?.isCashFreeAvailable == 0}>
                                        Cashfree Utility (1.5%)
                                    </option>
                                    {localStorage.getItem("userid") != "1111111" && (
                                        <option value={3} disabled={AllGateways?.isCashfreeEduAvailable == 0}>
                                            Cashfree Edu (1.2%)
                                        </option>
                                    )}
                                    <option value={1} disabled={AllGateways?.isRazorPayPGAvailable == 0}>
                                        Razor Pay (2.0%)
                                    </option>
                                    <option value={4} disabled={AllGateways?.isCashfreeFastAvailable == 0}>
                                        Cashfree Fast (1.8%)
                                    </option>
                                    <option value={5} disabled={AllGateways?.isZwitchAvailable == 0}>
                                        Zwitch (2.5%)
                                    </option>
                                </select>
                            </div>

                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <button type="button" onClick={() => setShowGatewayModal(false)} style={{ padding: '10px 20px', borderRadius: '4px', border: '1px solid #ccc', background: 'white' }}>
                                    Cancel
                                </button>
                                <button type="submit" style={{ padding: '10px 20px', borderRadius: '4px', border: 'none', background: '#e76f51', color: 'white', fontWeight: 'bold' }}>
                                    Proceed to Pay
                                </button>
                            </div>
                        </form>
                    </div>
                </ModalBody>
            </Modal>

            {/* Confirm Modal */}
            {showConfirmModal && (
                <Confirm
                    submitenabler={spin}
                    commissionPercentage={commissionPercentage}
                    setSpinner={setSpin}
                    payHandler={() => { }}
                    passBlc={totalPrice}
                    apidatasend={{ routeId: route, passengers, vehicleType, date: travelDate, time: departureTime }}
                    commissionamount={PayableAmount}
                    show={showConfirmModal}
                    PaymentGateWay={PaymentGateWay}
                    onHide={() => setShowConfirmModal(false)}
                />
            )}
        </div>
    );
};

export default FerryBooking;
